module.exports = __webpack_public_path__ + "static/media/hourglass.e2f07f41.svg";